/* eslint-disable max-len */
export default function CAEditCustomerAzureDirectiveController(
  $q,
  $rootScope,
  $scope,
  alerts,
  confirmDialog,
  orgDataService,
  ssDialogService,
) {
  const vm = this;

  vm.canEditLogo = true;
  vm.imgByteArray = null;
  vm.hasLogo = false;

  vm.handleActivateAzureClick = _handleActivateAzureClick;
  // vm.handleDeleteCustomerLogoClick = _handleDeleteCustomerLogoClick;

  _initEventListeners();

  function _initEventListeners() {
    // $scope.$on('refreshCustomer', (event, opt) => {
    //   if (opt.customerId === vm.customer.customerId) {
    //     _refresh().then(() => {
    //       $scope.$emit(`Customer logo ${vm.customer.customerId}refreshed`);
    //     });
    //   }
    // });
  }

  // function _refresh() {
  //   const dfdRefresh = $q.defer();
  //
  //   vm.canEditLogo = userService.getUserPermission('displayBankAdminUploadLogo');
  //
  //   if (vm.customer.logoDocumentId > 0) {
  //     orgDataService.downloadDocumentContent(vm.customer.logoDocumentId, vm.customer.customerId)
  //       .then((downloadLogoResponse) => {
  //         vm.imgByteArray = downloadLogoResponse.data.result;
  //         vm.hasLogo = true;
  //       });
  //   } else {
  //     vm.hasLogo = false;
  //   }
  //   return dfdRefresh.promise;
  // }

  // function _handleSetBankLogoClick($event) {
  //   ssDialogService.dialogs.admin.editCustomerLogoDialog = ssDialogService.alert(
  //     editBankLogoDialog.getOptions($event, {
  //       customerId: vm.customer.customerId,
  //     })
  //   );
  //   ssDialogService.show(ssDialogService.dialogs.admin.editCustomerLogoDialog);
  // }

  function _handleActivateAzureClick($event) {
    ssDialogService.dialogs.admin.confirmEnableCustomerAzureDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Activate Azure Active Directory',
        message: 'Are you sure you want to activate Azure Active Directory for the customer? Once activated, the change cannot be reverted',
        handleYesClick: _handleConfirmActivateClick,
        handleNoClick: _handleCancelActivateClick,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.admin.confirmEnableCustomerAzureDialog);
  }

  function _handleConfirmActivateClick() {
    return orgDataService.activateAzureAD(vm.customer.customerId)
      .then(() => {
        alerts.success('The Azure Active Directory is activated successfully.');
        $rootScope.$broadcast('refreshCustomer', { customerId: vm.customer.customerId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while activating Azure Active Directory.');
      });
  }

  function _handleCancelActivateClick() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.admin.confirmEnableCustomerAzureDialog);
  }
}

CAEditCustomerAzureDirectiveController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'confirmDialog',
  'orgDataService',
  'ssDialogService',
];
